var map = {
	"./ag.png": "7633",
	"./betsoft.png": "6780",
	"./bg.png": "72ab",
	"./blueprint.png": "03ac",
	"./dream_gamming.png": "9e18",
	"./evoplay.png": "26f8",
	"./funky_play.png": "fd42",
	"./gamatron.png": "54cb",
	"./gameplay.png": "3073",
	"./gdg.png": "6542",
	"./gg_fishing.png": "94f3",
	"./green_dragon.png": "3d0a",
	"./habanero.png": "0ef6",
	"./iron_dog.png": "45ac",
	"./joker.png": "9b82",
	"./kalamba.png": "7c05",
	"./maverick.png": "91cb",
	"./microgaming.png": "6e17",
	"./n2.png": "e2fa",
	"./pg.png": "6ec6",
	"./playstart.png": "2ccd",
	"./pragmatic.png": "7a08",
	"./quickspin.png": "770a",
	"./red_tiger.png": "c7b4",
	"./relax_gaming.png": "22d3",
	"./sa.png": "63c5",
	"./sexy_gaming.png": "0d4d",
	"./simpleplay.png": "8dfc",
	"./toptrend.png": "9576",
	"./wm.png": "3b99",
	"./yggdrasil.png": "1afc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21c3";